<template>
  <div class="dropdown">
    <button
      class="btn btn-light float-end"
      type="button"
      id="dropdownMenu2"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <span class="visually-hidden">Options</span>
      <i class="bi bi-three-dots-vertical"></i>
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
      <li v-if="permissions?.canView">
        <button
          class="dropdown-item"
          type="button"
          @click="$emit('viewClicked', id)"
        >
          View
        </button>
      </li>
      <li v-if="permissions?.canEdit">
        <button
          class="dropdown-item"
          type="button"
          @click="$emit('editClicked', id)"
        >
          Edit
        </button>
      </li>
      <li v-if="permissions?.canDelete">
        <button
          class="dropdown-item"
          type="button"
          @click="$emit('deleteClicked', id)"
        >
          Delete
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { Dropdown } from "bootstrap";
import PermissionSet from "@/guiide/ts/permissionSet";

export default defineComponent({
  name: "ThreeDotMenu",
  props: {
    id: { type: Number, required: true },
    permissions: { type: Object as () => PermissionSet, required: true }
  },
  emits: ["viewClicked", "editClicked", "deleteClicked"],
  setup() {
    onMounted(() => {
      const dropdownElement = document.getElementById("dropdownMenu2");
      if (dropdownElement) {
        new Dropdown(dropdownElement);
      }
    });
  }
});
</script>

<style scoped>
@media (max-width: 767px) {
  .dropdown-menu {
    position: static !important;
  }
}

.btn-light {
    background-color: transparent !important;
}
</style>
